module.exports = __webpack_public_path__ + "static/img/icon_home_second.fcc10ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_home_second.png
// module id = OjRW
// module chunks = 1